import React from 'react';
import clsx from 'clsx';
import { AlternateFlavor, AlternateFlavorConfig } from '@portal/processes/ShopV2/ShopV2.types';
import { CheckIcon } from '@portal/shared/studio/ContentPopup/Icons/CheckIcon';
import * as styles from './FlavorSelection.css';

type Flavor = AlternateFlavor | AlternateFlavorConfig;

interface FlavorOptionRadioProps {
  flavor: Flavor;
  isActive: boolean;
  onChange: (flavor: Flavor) => void;
  radioGroupName: string;
}

const hexToRgba = (hex: string, alpha: number): string => {
  const r = parseInt(hex.substring(1, 3), 16);
  const g = parseInt(hex.substring(3, 5), 16);
  const b = parseInt(hex.substring(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const FlavorOptionRadio: React.FC<FlavorOptionRadioProps> = ({
  flavor,
  isActive,
  onChange,
  radioGroupName
}) => {
  const isDisabled = flavor.outOfStock;
  const inputId = `${radioGroupName}-${flavor.id}`;

  let hoverColor = 'rgba(255, 255, 255, 0.29)';
  if (flavor.hoverColor) {
    hoverColor = flavor.hoverColor;
  } else if (flavor.color) {
    hoverColor = hexToRgba(flavor.color, 0.1);
  }

  return (
    <label
      htmlFor={inputId}
      className={styles.flavorOptionItem}
      data-active={isActive}
      data-disabled={isDisabled}>
      <input
        type="radio"
        id={inputId}
        name={radioGroupName}
        value={flavor.id}
        checked={isActive}
        onChange={() => onChange(flavor)}
        className={styles.radioInput}
      />
      <div
        className={`${styles.flavorOptionInnerContainer} ${styles.hoverableFlavorOptionInnerContainer}`}
        style={{ '--hover-color': hoverColor } as React.CSSProperties}
        data-disabled={isDisabled}
        data-active={isActive}>
        <div
          className={clsx(styles.flavorBubble)}
          style={
            flavor.color ? ({ '--flavor-color': flavor.color } as React.CSSProperties) : undefined
          }
          data-active={isActive}
        />
        <div className={styles.flavorOptionContent}>
          <div
            className={styles.checkIconWrapper}
            data-active={isActive}
            data-disabled={isDisabled}>
            <CheckIcon stroke={flavor.fontColor || 'black'} />
          </div>
          <div
            className={clsx(styles.flavorOptionTitle)}
            style={{ '--active-text-color': flavor.fontColor } as React.CSSProperties}
            data-text={flavor.title}
            data-disabled={isDisabled}>
            {flavor.title}
          </div>
        </div>
      </div>
    </label>
  );
};
